import React from "react"

const AboutOperator = props => {
  const operatorInfo = 
  [
    {
      "operatorName": "AWFIS",
      "operatorOverview": "Awfis Space Solutions Ltd. is India's largest flexible workspace provider based on total centers. It offers a wide spectrum of solutions, including coworking spaces (Awfis Flex), customized office solutions for enterprises (Awfis Enterprise), and integrated services covering design, construction, and facility management (Awfis Transform, Awfis Care). Listed on the Indian stock exchanges (NSE & BSE) since May 2024, Awfis caters to a diverse clientele ranging from startups and SMEs to large domestic and multinational corporations across various sectors. They aim to provide comprehensive workspace solutions beyond just physical space.",
      "cities": 17,
      "centers": 181,
      "seats": 111500,
      "highlights": [
        "India's largest flex workspace provider by center count",
        "Successfully listed via IPO in May 2024",
        "Offers integrated solutions including design, build, and facility management",
        "Presence in Tier 1 and growing rapidly in Tier 2 cities"
      ]
    },
    {
      "operatorName": "Smartworks",
      "operatorOverview": "Smartworks is a leading provider of managed office spaces in India, primarily focusing on large enterprises and multinational corporations. They specialize in offering customized, scalable, and technology-enabled office solutions, often leasing large floor plates or entire buildings to cater to significant workforce requirements. Their model emphasizes flexibility, cost-efficiency, and creating productive environments tailored to enterprise needs.",
      "cities": 14,
      "centers": 40,
      "seats": 90000,
      "highlights": [
        "Specializes in large enterprise clients (Fortune 500s, MNCs)",
        "Significant portfolio size (approx. 8 million sq ft)",
        "Technology integration in office spaces",
        "Backed by Singapore's Keppel Land"
      ]
    },
    {
      "operatorName": "WeWork",
      "operatorOverview": "WeWork India operates the WeWork brand in the country under a distinct entity (majority owned by funds managed by BPEA EQT and WeWork India management, separate from WeWork Global). It provides premium flexible workspace solutions, including private offices, custom buildouts, and coworking memberships. Known for its design aesthetics, community engagement programs, and prime locations, WeWork India serves a broad clientele from freelancers to large enterprises.",
      "cities": 8,
      "centers": 54,
      "seats": 90000,
      "highlights": [
        "Operates independently from WeWork Global",
        "Strong brand recognition and premium positioning",
        "Focus on community building and member events",
        "Network across major Tier 1 cities"
      ]
    },
    {
      "operatorName": "Cowrks",
      "operatorOverview": "Cowrks, backed by Brookfield Asset Management, is a provider of premium and enterprise-focused flexible workspace solutions. They emphasize high-quality design, Grade A building locations, and technology integration to create sophisticated work environments. Cowrks primarily caters to established companies, large enterprises, and professionals seeking upscale amenities and services.",
      "cities": 6,
      "centers": 9,
      "seats": 28000,
      "highlights": [
        "Part of Brookfield Asset Management portfolio",
        "Focus on premium segment and enterprise clients",
        "Located in prime Grade A commercial real estate",
        "Emphasis on design, technology, and member experience"
      ]
    },
    {
      "operatorName": "Indiqube",
      "operatorOverview": "Indiqube specializes in providing end-to-end, customized, and managed office spaces primarily for startups, scale-ups, and enterprises. They offer scalable solutions, often managing entire buildings or large dedicated floors, complete with interior design, fit-outs, and ongoing operations management. Indiqube leverages its proprietary technology platform (MiQube) for efficient space management and service delivery.",
      "cities": 15,
      "centers": 85,
      "seats": 100000,
      "highlights": [
        "Focus on scalable, customized enterprise office solutions",
        "Proprietary technology platform 'MiQube'",
        "Strong presence in South India (especially Bengaluru)",
        "Manages over 7 million sq ft of office space"
      ]
    },
    {
      "operatorName": "WorkEZ",
      "operatorOverview": "WorkEZ is a prominent flexible workspace provider primarily operating in Chennai. It is known for offering premium, well-designed coworking spaces and private offices with high-quality infrastructure and amenities. WorkEZ caters to a mix of SMEs, large domestic companies, and MNCs within the Chennai market.",
      "cities": 1,
      "centers": 10,
      "seats": 20000,
      "highlights": [
        "Leading flexible workspace operator in Chennai",
        "Known for premium fit-outs and design aesthetics",
        "Strong local market presence and reputation",
        "Focus on providing a high-quality work environment"
      ]
    },
    {
      "operatorName": "Urban Vault",
      "operatorOverview": "Urban Vault offers flexible coworking spaces and managed office solutions, with a strong initial focus on Bangalore's key business hubs. They cater primarily to startups, small to medium-sized enterprises (SMEs), and freelancers, providing adaptable workspace options in various micro-markets.",
      "cities": 2,
      "centers": 18,
      "seats": 8000,
      "highlights": [
        "Strong network across Bangalore's micro-markets",
        "Offers flexible plans suitable for startups and SMEs",
        "Growing portfolio in managed office spaces",
        "Presence established in Hyderabad"
      ]
    },
    {
      "operatorName": "91Springboard",
      "operatorOverview": "91 Springboard is one of India's original coworking space providers, known for fostering a strong community for startups and entrepreneurs. They offer a range of flexible workspace options, including coworking desks, private offices, and enterprise solutions, across multiple cities. A key focus is on networking events and support services for the startup ecosystem.",
      "cities": 8,
      "centers": 22,
      "seats": 25000,
      "highlights": [
        "Early player in the Indian coworking market",
        "Strong emphasis on community building for startups",
        "Pan-India presence in major cities",
        "Backed by investors like Google for Startups, Anthill Ventures"
      ]
    },
    {
      "operatorName": "Innov8",
      "operatorOverview": "Innov8, acquired by OYO in 2019, operates as a premium coworking brand within the OYO Workspaces portfolio. It is recognized for its creatively designed interiors, focus on ergonomics, and prime locations in major cities. Innov8 caters to a diverse clientele, including freelancers, startups, SMEs, and corporates, seeking vibrant and productive work environments.",
      "cities": 9,
      "centers": 24,
      "seats": 18000,
      "highlights": [
        "Acquired by OYO in 2019",
        "Known for distinctive, vibrant interior design",
        "Emphasis on ergonomic furniture and amenities",
        "Operates in key central business districts"
      ]
    },
    {
      "operatorName": "Aster Group",
      "operatorOverview": "Aster Coworking operates a modern and professional co-working space located in Pune (Shivajinagar), India. They offer a range of flexible workspace options including private offices, dedicated desks, and hot desks, catering to professionals and entrepreneurs. Amenities include high-speed internet, meeting rooms, and administrative support.",
      "cities": 1,
      "centers": 1,
      "seats": 200,
      "highlights": [
        "Located in Shivajinagar, Pune",
        "Offers desks, private offices, meeting rooms"
      ]
    },
    {
      "operatorName": "Plus Offices",
      "operatorOverview": "Plus Offices provides coworking spaces primarily in Gurugram (Gurgaon), with locations identified in Golf Course Extension Road, Sector 44, and Sector 67. They offer dedicated desks and private cabins, focusing on providing functional and accessible workspaces in key commercial hubs of the city.",
      "cities": 1,
      "centers": 3,
      "seats": 1200,
      "highlights": [
        "Multiple locations within Gurugram",
        "Focuses on core coworking offerings (desks, cabins)"
      ]
    },
    {
      "operatorName": "Synq.Work",
      "operatorOverview": "Synq.Work offers coworking spaces primarily in the Gurgaon/Gurugram area, with known locations including Golf Course Road Extension and Sector 44 (Unitech Cyber Park). They provide flexible workspace solutions catering to professionals and businesses in the NCR region.",
      "cities": 1,
      "centers": 2,
      "seats": 600,
      "highlights": [
        "Presence in key Gurgaon business districts",
        "Offers standard flexible workspace solutions"
      ]
    },
    {
      "operatorName": "Supreme Cowork",
      "operatorOverview": "Supreme Cowork is a coworking space provider operating in Delhi-NCR. A known center is located within the DLF City Centre Mall in Shalimar Bagh, North Delhi, suggesting a focus on accessible and potentially retail-integrated workspace options.",
      "cities": 1,
      "centers": 1,
      "seats": 300,
      "highlights": [
        "Location within DLF City Centre Mall, Shalimar Bagh",
        "Accessible coworking option in North Delhi"
      ]
    },
    {
      "operatorName": "ABL Workspaces",
      "operatorOverview": "ABL Workspaces provides coworking spaces across several locations in Delhi-NCR, including Green Park, Connaught Place, and Okhla. They offer open desks and likely other flexible workspace options, targeting professionals and businesses seeking accessible spaces in prime areas of the capital region.",
      "cities": 1,
      "centers": 4,
      "seats": 800,
      "highlights": [
        "Multiple locations across Delhi-NCR",
        "Focus on accessible coworking in prime areas"
      ]
    },
    {
      "operatorName": "One Co.Work",
      "operatorOverview": "One Co.Work is a coworking space provider with centers in multiple Indian cities, including Chennai (Thousand Lights), Delhi, and Gurgaon. They offer dedicated desks and potentially private cabins, providing standard amenities and facilities in key urban business locations.",
      "cities": 3,
      "centers": 6,
      "seats": 1500,
      "highlights": [
        "Presence in multiple major cities (Chennai, Delhi, Gurgaon)",
        "Offers core coworking products"
      ]
    },
    {
      "operatorName": "Unispace",
      "operatorOverview": "Unispace Business Center provides serviced office spaces and associated business support services in several major Indian cities including Hyderabad, Bangalore, Chennai, Pune, and Gurgaon. They focus on offering professional, ready-to-use office environments with essential amenities.",
      "cities": 5,
      "centers": 6,
      "seats": 1500,
      "highlights": [
        "Provides serviced offices",
        "Presence across multiple Tier-1 cities"
      ]
    },
    {
      "operatorName": "Workden Coworking",
      "operatorOverview": "Workden Coworking appears to be a smaller, potentially local coworking space provider in India. Information regarding specific locations and offerings is limited, suggesting it offers basic flexible workspace solutions on a smaller scale.",
      "cities": 1,
      "centers": 1,
      "seats": 100,
      "highlights": [
        "Local coworking option (Information limited)"
      ]
    },
    {
      "operatorName": "Amigo Coworking Space",
      "operatorOverview": "Amigo Coworking Space seems to be a local or small-scale coworking provider in India. Specific details about its operations are scarce, indicating it likely offers fundamental workspace facilities to a local market.",
      "cities": 1,
      "centers": 1,
      "seats": 100,
      "highlights": [
        "Local coworking facility (Information limited)"
      ]
    },
    {
      "operatorName": "Incubex Coworking",
      "operatorOverview": "Incubex is a significant coworking and business center provider heavily concentrated in Bangalore. Operating numerous 'Hubs' across key areas like HSR Layout, Koramangala, Indiranagar, and JP Nagar, they offer versatile and scalable workspaces suitable for various team sizes within the city.",
      "cities": 1,
      "centers": 35,
      "seats": 7000,
      "highlights": [
        "Extensive network of 'Hubs' within Bangalore",
        "Strong presence in key Bangalore tech/business areas",
        "Caters to diverse team sizes"
      ]
    },
    {
      "operatorName": "Office Republic Coworking",
      "operatorOverview": "Office Republic Coworking provides a range of flexible workspace solutions including coworking spaces, managed/serviced offices, virtual offices, and meeting rooms across multiple locations in Bangalore (e.g., Bannerghatta Road). They emphasize cost-effective, flexible, and customizable options with comprehensive amenities.",
      "cities": 1,
      "centers": 4,
      "seats": 800,
      "highlights": [
        "Multiple locations across Bangalore",
        "Offers a full suite of flex space products (coworking, managed, virtual)",
        "Focus on cost-effectiveness and flexibility"
      ]
    },
    {
      "operatorName": "CoworkInsta",
      "operatorOverview": "CoworkInsta offers affordable coworking spaces in Gurugram, with a known location in DLF Phase IV near Huda City Centre metro station. They aim to provide a vibrant and cozy environment with essential services for professionals and companies seeking budget-friendly options.",
      "cities": 1,
      "centers": 1,
      "seats": 300,
      "highlights": [
        "Focus on affordability",
        "Located in Gurugram (DLF Phase IV)",
        "Near Huda City Centre metro"
      ]
    },
    {
      "operatorName": "WorkWings",
      "operatorOverview": "WorkWings appears to be a smaller, local coworking space provider in India. Detailed public information about its locations and specific services is limited, suggesting it provides basic flexible workspace solutions.",
      "cities": 1,
      "centers": 1,
      "seats": 100,
      "highlights": [
        "Local coworking option (Information limited)"
      ]
    },
    {
      "operatorName": "Co-Offiz",
      "operatorOverview": "Co-Offiz is a coworking space provider with multiple centers across Delhi-NCR, including locations in Netaji Subhash Place, Preet Vihar, Janakpuri (Delhi), Noida Sector 63, and Gurugram Sector 58. They offer flexible seats, dedicated desks, and private cabins, highlighting convenient access near metro stations.",
      "cities": 3,
      "centers": 5,
      "seats": 2350,
      "highlights": [
        "Presence across Delhi, Noida, and Gurugram",
        "Metro connectivity emphasized for locations",
        "Offers flexible seats, dedicated desks, private cabins"
      ]
    },
    {
      "operatorName": "Opulence CoWo Pvt Ltd",
      "operatorOverview": "Opulence CoWo Pvt Ltd is registered as a private limited company based in Ahmedabad, Gujarat (incorporated in 2019). Publicly available information regarding its current operations as an active, public-facing coworking space provider is limited or dated.",
      "cities": 1,
      "centers": 0,
      "seats": 0,
      "highlights": [
        "Registered entity in Ahmedabad",
        "Operational status as coworking provider unclear"
      ]
    },
    {
      "operatorName": "GoodWorks CoWork",
      "operatorOverview": "GoodWorks CoWork specializes in providing premium, fully-managed office spaces, particularly focusing on setting up Global Capability Centers (GCCs) for enterprises in Bangalore. They operate in key tech corridors like Whitefield, ORR, Electronic City, and the CBD, offering spacious, custom-built, and tech-enabled environments with comprehensive operational support.",
      "cities": 1,
      "centers": 5,
      "seats": 4000,
      "highlights": [
        "Specializes in Global Capability Center (GCC) setup",
        "Focus on enterprise clients in Bangalore",
        "Premium managed offices in key tech hubs",
        "Offers unified GCC platform 'Sansovi'"
      ]
    },
    {
      "operatorName": "Spring House Coworking",
      "operatorOverview": "Spring House offers a mix of coworking and managed office spaces across numerous locations within Delhi-NCR. Their centers are spread across Gurugram (Golf Course Road, Sohna Road, MG Road, etc.), Delhi (Janakpuri, Naraina), and Noida (Sector 62), catering to startups and established enterprises with flexible, professional environments.",
      "cities": 3,
      "centers": 12,
      "seats": 3000,
      "highlights": [
        "Strong presence across Delhi-NCR (Gurugram, Delhi, Noida)",
        "Offers both coworking and managed office solutions",
        "Multiple centers in key Gurugram areas"
      ]
    },
    {
      "operatorName": "DevX",
      "operatorOverview": "DevX is a rapidly expanding Indian workspace provider offering coworking spaces, managed offices, and serviced offices. They have a wide footprint across approximately 23 cities (Tier 1, 2, and 3). Positioned as a community for innovators, DevX also runs an accelerator program and a venture fund to support startups.",
      "cities": 23,
      "centers": 25,
      "seats": 18000,
      "highlights": [
        "Extensive pan-India presence including Tier 2/3 cities",
        "Offers startup accelerator (DevX Accelerator) and venture fund",
        "Provides managed/serviced offices alongside coworking",
        "Focus on building an innovation ecosystem"
      ]
    },
    {
      "operatorName": "Venture X Workspace",
      "operatorOverview": "Venture X is a global franchise brand offering upscale flexible workspaces. In India, they have a known presence in Gurgaon (Golf Course Road Extension). They provide premium private offices and coworking spaces characterized by professional design, high-end amenities, and a hospitality-focused approach.",
      "cities": 1,
      "centers": 1,
      "seats": 400,
      "highlights": [
        "International franchise brand",
        "Premium/upscale workspace offering",
        "Known location in Gurgaon"
      ]
    },
    {
      "operatorName": "AltF",
      "operatorOverview": "AltF provides coworking and flexible office solutions primarily focused on the Delhi-NCR region (Delhi, Noida, Gurgaon), with recent expansion into Hyderabad. They offer a variety of workspace types, including private offices, team rooms, director cabins, and virtual offices, aiming for a blend of affordability and high quality for MSMEs, startups, and professionals.",
      "cities": 4,
      "centers": 18,
      "seats": 7000,
      "highlights": [
        "Strong presence and multiple centers in Delhi-NCR",
        "Expanding significantly into Hyderabad",
        "Offers diverse private office configurations",
        "Focus on cost-effective, quality workspaces"
      ]
    },
    {
      "operatorName": "Oahfeo",
      "operatorOverview": "Oahfeo operates a coworking space in Sector 44, Gurgaon, branded as 'The Underground Oasis'. Located near Huda City Center, they offer dedicated desks, private cabins, and potentially managed office solutions, providing essential amenities in a key business district of Gurgaon.",
      "cities": 1,
      "centers": 1,
      "seats": 300,
      "highlights": [
        "Unique branding ('The Underground Oasis')",
        "Located in Gurgaon Sector 44",
        "Offers desks, cabins, and managed options"
      ]
    },
    {
      "operatorName": "Ofis Square",
      "operatorOverview": "Ofis Square provides a range of flexible workspace solutions including coworking, managed offices, virtual offices, and meeting rooms. They operate four centers across key micro-markets in Noida (Sector 62, Sector 3) and Gurugram (Sohna Road, MG Road), managing a significant area of commercial real estate.",
      "cities": 2,
      "centers": 4,
      "seats": 4000,
      "highlights": [
        "Presence in both Noida and Gurugram key areas",
        "Manages over 1.6 Lac sq ft",
        "Offers a comprehensive suite of flex space products"
      ]
    },
    {
      "operatorName": "CoKarma",
      "operatorOverview": "CoKarma is a coworking space provider primarily focused on the Hyderabad market. They operate multiple centers across the city in locations like Kondapur, HITEC City, Gachibowli, Himayatnagar, and Jubilee Hills, offering open seats, private offices, and executive cabins designed to foster collaboration among entrepreneurs and businesses.",
      "cities": 1,
      "centers": 6,
      "seats": 1500,
      "highlights": [
        "Strong focus and multiple locations within Hyderabad",
        "Catters to entrepreneurs, creatives, and businesses",
        "Present in key Hyderabad IT and business hubs"
      ]
    },
    {
      "operatorName": "The Hive",
      "operatorOverview": "The Hive operates premium, design-led coworking spaces in India, often situated within prime commercial buildings or integrated with Virtuous Retail shopping centers in cities like Bangalore, Chennai, and Pune. They focus on creating vibrant communities through events and offering high-quality amenities.",
      "cities": 3,
      "centers": 4,
      "seats": 2500,
      "highlights": [
        "Premium design and amenities",
        "Often co-located with Virtuous Retail malls",
        "Focus on community building and events",
        "Presence in Bangalore, Chennai, Pune"
      ]
    },
    {
      "operatorName": "TRIOS Coworking",
      "operatorOverview": "TRIOS Coworking appears to be a smaller or local coworking space provider in India. Publicly available information about its specific locations, scale of operations, and service offerings is limited, suggesting it provides basic flexible workspace solutions.",
      "cities": 1,
      "centers": 1,
      "seats": 100,
      "highlights": [
        "Local coworking option (Information limited)"
      ]
    },
    {
      "operatorName": "UrbanWrk",
      "operatorOverview": "UrbanWrk specializes in providing managed office solutions and customized flexible workspaces tailored for enterprises. They operate in major Indian cities including Mumbai, Pune, Hyderabad, and Bangalore, focusing on delivering scalable, tech-enabled, and productive office environments for larger teams.",
      "cities": 4,
      "centers": 6,
      "seats": 8000,
      "highlights": [
        "Strong focus on managed offices and enterprise solutions",
        "Presence in key Tier-1 cities (Mumbai, Pune, Hyderabad, Bangalore)",
        "Technology integration in workspaces",
        "Caters to medium-to-large enterprises"
      ]
    },
    {
      "operatorName": "Incuspaze",
      "operatorOverview": "Incuspaze is a major pan-India workspace provider with a large network of over 44 centers across 18+ cities, including Tier 1 and Tier 2 locations. They offer a diverse portfolio including coworking spaces, managed offices, and enterprise solutions, managing over 4 million sq ft and catering to MSMEs and large corporations with an emphasis on design and technology.",
      "cities": 18,
      "centers": 44,
      "seats": 40000,
      "highlights": [
        "Extensive pan-India network (18+ cities, 44+ centers)",
        "Large portfolio (4M sq ft, 40k+ seats)",
        "Offers diverse solutions including strong enterprise focus",
        "Emphasis on intuitive design and smart technology"
      ]
    },
    {
      "operatorName": "Apeejay Business Centre",
      "operatorOverview": "Apeejay Business Centre (ABC), part of the large Apeejay Surrendra Group, is a veteran provider of premium serviced offices and business center solutions in India. With locations in Kolkata, Mumbai, New Delhi, Hyderabad, Chennai, and Gurgaon, they offer ready-to-move-in offices, built-to-suit options, virtual offices, and meeting rooms in prime business districts.",
      "cities": 6,
      "centers": 8,
      "seats": 3000,
      "highlights": [
        "Part of Apeejay Surrendra Group conglomerate",
        "Long-standing player in the business center market",
        "Premium serviced office provider",
        "Presence in multiple Tier-1 cities' CBDs"
      ]
    },
    {
      "operatorName": "BHIVE",
      "operatorOverview": "BHIVE is a leading workspace provider with a dense network primarily across Bangalore (HSR Layout, MG Road, Indiranagar, Whitefield, Koramangala, etc.) and a center in Mumbai (BKC). They offer multiple tiers of coworking and managed office spaces (Platinum, Premium, Workspace), often strategically located near metro stations, and are well-known within the startup ecosystem.",
      "cities": 2,
      "centers": 25,
      "seats": 12000,
      "highlights": [
        "Dominant presence across Bangalore",
        "Expansion into Mumbai (BKC)",
        "Multiple tiers of workspace offerings",
        "Strong connection to startup community",
        "Locations often near metro stations"
      ]
    },
    {
      "operatorName": "Clayworks",
      "operatorOverview": "Clayworks offers community-centric coworking spaces in Bangalore, with centers in locations like Arakere (Bannerghatta Road), JP Nagar, and the CBD (Ashok Nagar). They differentiate themselves through aesthetically pleasing design, lush open spaces, community engagement, and unique amenities like handcrafted beverages.",
      "cities": 1,
      "centers": 3,
      "seats": 700,
      "highlights": [
        "Focus on community, aesthetics, and unique ambience",
        "Multiple locations within Bangalore",
        "Emphasis on open spaces and quality beverages"
      ]
    },
    {
      "operatorName": "iSprout",
      "operatorOverview": "iSprout Business Centre provides comprehensive flexible workspace solutions, including coworking spaces and managed/enterprise offices. They have a strong foothold in South Indian cities such as Hyderabad, Chennai, Bangalore, Pune, and Vijayawada, catering to a mix of individual professionals, startups, and corporate clients.",
      "cities": 5,
      "centers": 18,
      "seats": 12000,
      "highlights": [
        "Strong presence across South India (Hyderabad, Chennai, Bangalore, Pune, Vijayawada)",
        "Offers both coworking and managed/enterprise solutions",
        "Growing network in multiple cities"
      ]
    }
  ];
  const filteredData = operatorInfo.filter(item => item.operatorName === props.operatorName)
  const newdata = filteredData[0]

  return (
    <React.Fragment>
      {newdata ? (
        <div className="operator-profile">
          <div className="operator-header fade-in">
            {newdata.operatorLogo && (
              <div className="logo-container">
                <img src={newdata.operatorLogo} alt={`${newdata.operatorName} logo`} />
              </div>
            )}
            <h4>About {newdata.operatorName}</h4>
          </div>
          
          <div className="operator-overview fade-in">
            <p>{newdata.operatorOverview}</p>
          </div>

          <div className="operator-stats fade-in">
            <div className="stat-item">
              <span className="stat-number">{newdata.cities}</span>
              <span className="stat-label">Cities</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{newdata.centers}</span>
              <span className="stat-label">Centers</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{(newdata.seats).toLocaleString()}</span>
              <span className="stat-label">Seats</span>
            </div>
          </div>

          <div className="operator-highlights">
            <h5>Key Brand Highlights</h5>
            <ul>
              {newdata.highlights.map((highlight, index) => (
                <li key={index} className="highlight-item" style={{ animationDelay: `${index * 0.1}s` }}>
                  {highlight}
                </li>
              ))}
            </ul>
          </div>

          <style jsx>{`
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            @keyframes slideIn {
              from {
                opacity: 0;
                transform: translateX(-20px);
              }
              to {
                opacity: 1;
                transform: translateX(0);
              }
            }

            .fade-in {
              animation: fadeIn 0.6s ease-out forwards;
            }

            .highlight-item {
              animation: slideIn 0.5s ease-out forwards;
              opacity: 0;
            }

            .operator-profile {
              background: #fff;
              margin: 1.5rem 0;
            }

            .operator-header {
              gap: 1.5rem;
            }

            .logo-container {
              width: 140px;
              height: 45px;
              display: flex;
              align-items: center;
              padding: 0.5rem;
              background: #f8f9fa;
              border-radius: 8px;
              transition: transform 0.2s ease;
            }

            .logo-container:hover {
              transform: scale(1.05);
            }

            .logo-container img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }


            .operator-overview {
              color: #4a5568;
              line-height: 1.8;
              margin-bottom: 1rem;
              font-size: 1rem;
            }

            .operator-stats {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
              gap: 1.5rem;
              margin-bottom: 1rem;
              padding: 1rem 1rem;
              background: #f8fafc;
              border-radius: 8px;
            }

            .stat-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
              padding: 1rem;
              background: white;
              border-radius: 8px;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              transition: transform 0.2s ease;
            }

            .stat-item:hover {
              transform: translateY(-2px);
            }

            .stat-number {
              font-size: 1.75rem;
              font-weight: 700;
              color: #2d3748;
              margin-bottom: 0.5rem;
            }

            .stat-label {
              font-size: 0.9rem;
              color: #718096;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }

            .operator-highlights {
              padding: 1rem 0rem;
            }

            .operator-highlights h5 {
              color: #2d3748;
              font-size: 1.25rem;
              margin: 0 0 1rem 0;
              font-weight: 600;
            }

            .operator-highlights ul {
              list-style: none;
              padding: 0;
              margin: 0;
            }

            .operator-highlights li {
              color: #4a5568;
              margin-bottom: 0.5rem;
              display: flex;
              align-items: center;
            }


            .operator-highlights li::before {
              content: "•";
              color: #4299e1;
              font-weight: bold;
              margin-right: 0.75rem;
            }

            @media (max-width: 768px) {
              .operator-header {
                flex-direction: column;
                gap: 1rem;
              }

              .logo-container {
                margin: 0 auto;
              }

              .operator-stats {
                grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
                gap: 1rem;
                padding: 1rem;
              }

              .stat-item {
                padding: 0.75rem;
              }

              .stat-number {
                font-size: 1.5rem;
              }

              .operator-highlights li {
                padding: 0.5rem 0.75rem;
              }
            }
          `}</style>
        </div>
      ) : null}
    </React.Fragment>
  )
}

export default AboutOperator
